import { createReducer } from '@reduxjs/toolkit';
import { initialState } from '../default';

import { getProductList } from './actions';
import { ProductState } from './types';

export default createReducer(initialState as ProductState, builder => {
  builder
    .addCase(getProductList.pending, state => {
      state.pending = true;
    })
    .addCase(getProductList.fulfilled, (state, { payload }) => {
      state.pending = false;
      state.fullfilled = true;
      state.data = payload;
    })
    .addCase(getProductList.rejected, state => {
      state.pending = false;
      state.error = true;
    });
});
